import React, { useState, useEffect } from 'react';
import CustomTable from '../../../../../customComponents/CustomTable';
import editIcon from './../../../../../../Assets/icons/Un-Checkbox.svg'; 
import './index.scss';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../../routes/routes';
import SearchInput from '../../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../../customComponents/CustomLoader';

const RTOList = () => {
  const [rtos, setRtos] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [ totalData, setTotalData ] = useState(0)
  const [totalActive, setTotalActive] = useState(0)
  const [ totalInactive, setTotalInactive ] = useState(0)
  const [ revenue, setRevenue ] = useState(0)
  const [ city, setCity ] = useState([])
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRtos();
    fetchCity();
  }, []);

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.get("/pincodestatecity/cityList", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data.data; // Access the data from the response object
      const cityOptions = data.map(city => ({
        value: city.city_id,
        label: city.city_name,
      }));
      setCity(cityOptions); // Assuming setCity is a state setter function
    } catch (error) {
      console.log(error); // Log the error for debugging purposes
    }
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchRtos(newPage);
  };
  const fetchRtos = async (page = 0, pageSize = 10) => {
    try {
      setLoading(true)
      const response = await axiosInstance.post('/rto/list', {
        orderBy: 'rto_id desc',
        page,
        pageSize,
        searchText:searchTerm
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        }
      });

      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1  
      }));

      const totalRecordsData = response?.data?.data?.totalRecords
      const totalCount = response?.data?.data?.total
      const totalRevenue = response?.data?.data?.total_active
      const unitSold = response?.data?.data?.total_inactive
      const revenueCount = response?.data?.data?.annual_revenue

      setTotalData(totalCount)
      setTotalActive(totalRevenue)
      setTotalInactive(unitSold)
      setRevenue(revenueCount)

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setRtos(formattedData); 
      // toastSuccess("Data fetched successfully!"); 
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize)); 
    } catch (error) {
      console.error('Error fetching RTO list:', error);
    }
    finally{
      setLoading(false)
    }
  };




  // Table headers
  const RTO_TABLE_HEADERS = [
    // "Sr No.",
    // "RTO ID",
    "Name",
    "Location",
    "Status",
    "Action"
  ];

  // Key mapping for CustomTable component
  const RTO_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    // "RTO ID": "rto_id",
    "Name": "rtolabel",
    "Location": "rtocity",
    "Status": "status",
    "Action": [
      { type: "edit", icon: editIcon, label: "Edit" },
    ]
  };
  const handleEdit = (rowData) => {
    console.log("clicked")
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITRTO}`, { state: { data: rowData } });
  }
  useEffect(() => {
    if (searchTerm === "") {
      fetchRtos();
    }
  }, [searchTerm]);

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>RTO Management</h5>
        </div>
        <div className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
        <div className='totalvalues' style={{borderRight: "1px solid lightgrey"}} >
            <h5>{totalData} </h5>
            <h6>All RTO</h6>
          </div>
          <div  className='totalvalues' style={{borderRight: "1px solid lightgrey"}}>
            <h5>{totalActive} </h5>
            <h6>Active RTO</h6>
          </div>
          <div className='totalvalues' style={{borderRight: "1px solid lightgrey"}}>
            <h5>{totalInactive} </h5>
            <h6>Inactive RTO</h6>
          </div>
          <div>
            <button className='addcustomerbutton' onClick={() => navigate('/admin/manage-dealer/rto/add-rto')}>
              Add RTO
            </button>
          </div>
        </div>
      </div>

      {/* <ListFilters city={city} clearSearch={clearFilter} handleSearch={handleSearch} /> */}

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>RTO List</h5>
            <div>
              <SearchInput
                placeholder="Search RTO"
                onSearch={fetchRtos}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
            </div>
          </div>
         
        </div>

        <CustomTable data={rtos} headers={RTO_TABLE_HEADERS} keyMapping={RTO_KEY_MAPPING} itemsPerPage={10}
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange} 
          totalRecords={totalRecords} 
          onEdit={handleEdit}
          />
      </div>
    </div>
      )}
    </div>
  );
};

export default RTOList;
